var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderOutreach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.25C17.9868 3.25 18.3857 3.41502 18.7363 3.76562C19.0866 4.1161 19.2506 4.51382 19.25 4.99902V8.25H25C25.4868 8.25 25.8857 8.41502 26.2363 8.76562C26.5866 9.1161 26.7506 9.51382 26.75 9.99902V25C26.75 25.4872 26.5853 25.8858 26.2354 26.2363C25.8862 26.5861 25.4885 26.7506 25.001 26.75H5C4.51297 26.75 4.11504 26.5856 3.76562 26.2363C3.45967 25.9304 3.29453 25.5864 3.25781 25.1777L3.25 24.999V10C3.25 9.51323 3.41448 9.11522 3.76465 8.76562C4.07164 8.45916 4.41539 8.2946 4.82227 8.25781L5.00098 8.25H10.75V5C10.75 4.51323 10.9145 4.11522 11.2646 3.76562C11.5716 3.45916 11.9154 3.2946 12.3223 3.25781L12.501 3.25H17.5ZM13 15.5H9.25V19.5H13V23.25H17V19.5H20.75V15.5H17V11.75H13V15.5ZM11.75 8.25H18.25V4.25H11.75V8.25Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderOutreach);
export default __webpack_public_path__ + "static/media/Provider Outreach.040bf08f2aee6ae3d2273669040b0f61.svg";
export { ForwardRef as ReactComponent };